import React, {
  createContext,
  SetStateAction,
  Dispatch,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import { ONBOARDING_STORAGE_KEY } from '../../constants';

/**
 * The Tutorial Popup Context
 */
export const TutorialContext = createContext<boolean>(false);

export const TutorialDispatchContext = createContext<Dispatch<SetStateAction<boolean>>>(undefined);

export function TutorialProvider({ children }: { children: ReactNode }) {
  const [tutorialOpen, settutorialOpen] = useState(false);

  useEffect(() => {
    if (localStorage) {
      const onboarding = localStorage.getItem(ONBOARDING_STORAGE_KEY) === 'true';
      if (onboarding) {
        settutorialOpen(true);
        localStorage.removeItem(ONBOARDING_STORAGE_KEY);
      }
    }
  }, []);

  return (
    <TutorialContext.Provider value={tutorialOpen}>
      <TutorialDispatchContext.Provider value={settutorialOpen}>
        {children}
      </TutorialDispatchContext.Provider>
    </TutorialContext.Provider>
  );
}
